import { Trash } from "@phosphor-icons/react";
import { Button, Dialog, Flex } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "../../../utils/hooks";

type DeleteTicketDialogProps = {
  ticketId?: string;
  onDelete(ticketId: string): void;
  onCancel(): void;
  isPending: boolean;
};

export function DeleteTicketDialog(props: DeleteTicketDialogProps) {
  const { t } = useTranslation("ui");
  const { isPending, onCancel, onDelete, ticketId } = props;
  const tickets = useAppSelector((state) => state.punttProjects.tickets);
  const ticket = useAppSelector((state) => state.ticket.value);

  const found = ticket ?? tickets.find((t) => t._id === ticketId);

  return (
    <Dialog.Root open={ticketId != null}>
      <Dialog.Content maxWidth="450px">
        <Dialog.Title>
          {t("tickets.deleteTicketDialog.deleteDocument")}
        </Dialog.Title>
        <Dialog.Description>
          Are you sure you want to delete <em>{found?.title}</em>?
        </Dialog.Description>

        <Flex gap="2" mt="3" justify="end">
          <Button
            data-testid="delete-ticket-dialog-button-29"
            variant="soft"
            color="gray"
            onClick={() => onCancel()}
          >
            {t("common:actions.cancel")}
          </Button>
          <Button
            data-testid="delete-ticket-dialog-button-32"
            color="red"
            onClick={() => onDelete(ticketId as string)}
            disabled={isPending}
            loading={isPending}
          >
            <Trash />
            Delete
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
